if(!customElements.get('localization-form-new')) {
  customElements.define(
    'localization-form-new',
    class LocalizationFormNew extends HTMLElement {
      constructor() {
        super();
        this.retries = 0;
        this.selectorForm = this.querySelector('form');
        this.toggler = this.querySelector('[data-localization-dropdown-toggler]');
        this.dropdown = this.querySelector('[data-localization-dropdown]');
        this.languageSelect = this.querySelector('select[name="language_code"]');
        this.languageCustomSelect = this.querySelector('[data-language-options]');
        this.languageToggler = this.querySelector('[data-language-dropdown-toggler]');
        this.countryToggler = this.querySelector('[data-country-dropdown-toggler]');
        this.languageFlag = this.querySelector('[data-language-flag]');

        this.customSelect = this.querySelectorAll('custom-select');

        this.toggler.addEventListener('click', this.onTogglerClick.bind(this));
        this.customSelect.forEach((customSelect) => {
          this.enableCustomSelect(customSelect);
        })

        this.selectorForm.addEventListener('submit', this.onSwitcherSubmit.bind(this));

        document.addEventListener('DOMContentLoaded',  () => {
          this.setLanguageOptions();
          this.setLanguageChangeListener();
        });
      }

      onTogglerClick(evt) {
        evt.preventDefault();

        if(this.toggler.ariaExpanded == 'true') {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      }

      async klaviyoRegisterLanguage(lang) {
        if(window.klaviyo) {
          const langObject = {
            "language": lang
          }
          if(window.customer.email) {
            langObject.email = window.customer.email
          }

          await klaviyo.identify(langObject);
        }
      }

      async registerAttentiveLanguage(lang) {
        if(!window.customer.email) return;
        const customerEmail = window.customer.email;
        const customerConsent = Shopify.customerPrivacy.currentVisitorConsent();
        if(customerConsent.preferences = 'yes') {
          await fetch(
            "https://hook.us1.make.com/vchwf94yk6uhn7vsov49xe407hrn5h2u",
            {
              method: "post",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                "email": customerEmail,
                "language": lang
              })
            }
          );
        }
      }


      onSwitcherSubmit(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        const formData = new FormData(this.selectorForm);
        const selectedCountryCode = formData.get('country_code').toLowerCase();
        const selectedLanguageCode = formData.get('language_code').toLowerCase();

        this.klaviyoRegisterLanguage(selectedLanguageCode);
        this.registerAttentiveLanguage(selectedLanguageCode);

        if(this.selectorForm.dataset.enableUrlRewrite == 'true') {
          const targetRoot = this.getTargetRoot({
            countryCode: selectedCountryCode,
            languageCode: selectedLanguageCode
          })

          if(targetRoot == Shopify.routes.root) {
            this.closeCustomSelectDropdown();
            return;
          }
          if(targetRoot == "/") {
            document.location.href = document.location.origin + document.location.pathname.replace(Shopify.routes.root.replaceAll('/', ''), "")
            return;
          }

          if(Shopify.routes.root !== '/') {
            document.location.href = document.location.origin + document.location.pathname.replace(Shopify.routes.root.replaceAll('/', ''), `${targetRoot}`).replace('//', '/')
            return;
          }

          document.location.href = document.location.origin + "/" + targetRoot + "/" + document.location.pathname;
        } else {
          const currentLanguageCode = Weglot.getCurrentLang();

          if(currentLanguageCode !== selectedLanguageCode) {
            Weglot.switchTo(selectedLanguageCode);
            this.closeDropdown();
          }

          if(Shopify.country.toLowerCase() !== selectedCountryCode) {
            setTimeout(() => {
              this.selectorForm.submit();
            }, 1000)
          }
        }
      }

      getTargetRoot({countryCode, languageCode}) {
        let targetRoot = "/";

        if(countryCode !== "us") {
          return `${languageCode}-${countryCode}`
        }

        if(languageCode !== "en") {
          return `${languageCode}`
        }

        return targetRoot;
      }

      openDropdown() {
        this.dropdown.removeAttribute('hidden');
        this.toggler.ariaExpanded = "true";
      }

      closeDropdown() {
        this.dropdown.setAttribute('hidden', true);
        this.toggler.ariaExpanded = "false";
      }

      setLanguageOptions() {
        if(this.retries == 100) {
          console.error('[Localization Form] - Retried 100 times, stop recursive calling');
          return;
        }

        if(!window.Weglot?.initialized) {
          this.retries += 1;
          setTimeout(() => {
            this.setLanguageOptions();
          }, 300);
          return;
        }

        this.languageToggler.querySelector('[data-selected-text]').innerText = window.Weglot.getLanguageName(window.Weglot.getCurrentLang());
        this.languageFlag.innerText = window.Weglot.getCurrentLang().toUpperCase();
        const languages = window.Weglot.options.languages.map((language) => language.language_to);
        languages.unshift(window.Weglot.options.language_from);

        languages.forEach((language) => {
          const option = document.createElement('option');
          option.value = language;
          option.text = window.Weglot.getLanguageName(language);
          if(language == window.Weglot.getCurrentLang()) {
            option.selected = true;
          }
          this.languageSelect.appendChild(option);

          const customOption = document.createElement('li');
          customOption.setAttribute('value', language);
          customOption.innerText = window.Weglot.getLanguageName(language);
          customOption.classList.add('custom-select__option');

          if(language == window.Weglot.getCurrentLang()) {
            customOption.setAttribute('aria-current', true);
          }

          this.languageCustomSelect.appendChild(customOption);
          this.languageToggler
        })
      }

      setLanguageChangeListener() {
        const scopedLangFlag = this.languageFlag;
        if(this.retries == 100) {
          console.error('[Localization Form] - Retried 100 times, stop recursive calling');
          return;
        }

        if(!window.Weglot?.initialized) {
          this.retries += 1;
          setTimeout(() => {
            this.setLanguageChangeListener();
          }, 300);
          return;
        }

        Weglot.on('languageChanged', function(lang) {
          scopedLangFlag.innerText = lang.toUpperCase();
        })
      }

      enableCustomSelect(customSelect) {
        const togglerButton = customSelect.querySelector('[data-custom-select-toggler]');
        const regularSelect = customSelect.querySelector('select');
        const customSelectDropdown = customSelect.querySelector('[data-custom-select-options]');

        customSelectDropdown.addEventListener('click', (evt) => {
          regularSelect.value = evt.srcElement.getAttribute('value');
          regularSelect.dispatchEvent(new Event('change'));
        })

        regularSelect.addEventListener('change', (evt) => {
          const customValues = customSelectDropdown.querySelectorAll('li');
          customValues.forEach((element) => {
            if(element.getAttribute('value') == evt.target.value) {
              element.setAttribute('aria-current', true);
              togglerButton.querySelector('[data-selected-text]').innerHTML = element.innerHTML;
            } else {
              element.removeAttribute('aria-current');
            }
          })
          this.closeCustomSelectDropdown(togglerButton, customSelectDropdown);
        })

        togglerButton.addEventListener('click', (evt) => {
          if(togglerButton.ariaExpanded == 'true') {
            this.closeCustomSelectDropdown(togglerButton, customSelectDropdown);
          } else {
            this.openCustomSelectDropdown(togglerButton, customSelectDropdown);

          }
        })
      }

      openCustomSelectDropdown(togglerButton,dropdown) {
        dropdown.removeAttribute('hidden')
        togglerButton.setAttribute('aria-expanded', 'true');
      }

      closeCustomSelectDropdown(togglerButton,dropdown) {
        dropdown.setAttribute('hidden', true)
        togglerButton.setAttribute('aria-expanded', 'false');
      }
    }
  )
}